import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { CustomRepoUrlPicker } from './CustomRepoUrlPicker';
import { customRepoUrlPickerValidation } from './utils';

export const CustomRepoUrlPickerFieldExtension = FormFieldBlueprint.make({
  name: 'custom-repo-url-picker',
  params: {
    field: async () =>
      createFormField({
        name: 'CustomRepoUrlPicker',
        component: CustomRepoUrlPicker as any,
        validation: (value, validation) =>
          customRepoUrlPickerValidation(value as any, validation),
        schema: makeFieldSchema({
          output: z => z.record(z.string(), z.unknown()),
          uiOptions: z =>
            z.object({
              allowedOrganizations: z
                .array(z.string())
                .optional()
                .describe('Organizations allowed as the repository name prefix'),
              defaultOrganization: z
                .string()
                .optional()
                .describe('Default organization / repository name prefix'),
              allowedHosts: z
                .array(z.string())
                .optional()
                .describe('Allowed SCM hosts'),
              defaultHost: z.string().optional().describe('Default SCM host'),
              allowedNamespaces: z
                .array(z.string())
                .optional()
                .describe(
                  'Allowed repository locations. When omitted, team paths are loaded from the catalog',
                ),
              defaultNamespace: z
                .string()
                .optional()
                .describe('Default repository location / namespace'),
              projectTypes: z
                .array(z.string())
                .optional()
                .describe('Allowed project types used in the repository name'),
              defaultProjectType: z
                .string()
                .optional()
                .describe('Default project type'),
            }),
        }),
      }),
  },
});
